/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_StrategyInputs */

const id_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategi`)
};

const ms_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategi`)
};

const da_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategi`)
};

const de_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategie`)
};

const en_us2_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategy`)
};

const es_es2_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia`)
};

const es_mx2_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia`)
};

const fil_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratehiya`)
};

const fr_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stratégie`)
};

const it_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategia`)
};

const hu_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stratégia`)
};

const nl_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategie`)
};

const no_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategi`)
};

const pl_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategia`)
};

const pt_br2_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia`)
};

const pt_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia`)
};

const ro_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategie`)
};

const fi_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategia`)
};

const sv_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategi`)
};

const vi_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiến thuật`)
};

const tr_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strateji`)
};

const cs_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategie`)
};

const bg_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегия`)
};

const ru_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегия`)
};

const uk_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегія`)
};

const ar_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استراتيجية`)
};

const hi_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्ट्रेटेजी`)
};

const th_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วางแผน`)
};

const ja_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストラテジー`)
};

const zh_cn2_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`策略`)
};

const zh_hant1_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`策略`)
};

const ko_nav_strategy = /** @type {(inputs: Nav_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전략`)
};

/**
* | output |
* | --- |
* | "Strategy" |
*
* @param {Nav_StrategyInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_strategy = /** @type {((inputs?: Nav_StrategyInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_StrategyInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_strategy(inputs)
	if (locale === "ms") return ms_nav_strategy(inputs)
	if (locale === "da") return da_nav_strategy(inputs)
	if (locale === "de") return de_nav_strategy(inputs)
	if (locale === "en-US") return en_us2_nav_strategy(inputs)
	if (locale === "es-ES") return es_es2_nav_strategy(inputs)
	if (locale === "es-MX") return es_mx2_nav_strategy(inputs)
	if (locale === "fil") return fil_nav_strategy(inputs)
	if (locale === "fr") return fr_nav_strategy(inputs)
	if (locale === "it") return it_nav_strategy(inputs)
	if (locale === "hu") return hu_nav_strategy(inputs)
	if (locale === "nl") return nl_nav_strategy(inputs)
	if (locale === "no") return no_nav_strategy(inputs)
	if (locale === "pl") return pl_nav_strategy(inputs)
	if (locale === "pt-BR") return pt_br2_nav_strategy(inputs)
	if (locale === "pt") return pt_nav_strategy(inputs)
	if (locale === "ro") return ro_nav_strategy(inputs)
	if (locale === "fi") return fi_nav_strategy(inputs)
	if (locale === "sv") return sv_nav_strategy(inputs)
	if (locale === "vi") return vi_nav_strategy(inputs)
	if (locale === "tr") return tr_nav_strategy(inputs)
	if (locale === "cs") return cs_nav_strategy(inputs)
	if (locale === "bg") return bg_nav_strategy(inputs)
	if (locale === "ru") return ru_nav_strategy(inputs)
	if (locale === "uk") return uk_nav_strategy(inputs)
	if (locale === "ar") return ar_nav_strategy(inputs)
	if (locale === "hi") return hi_nav_strategy(inputs)
	if (locale === "th") return th_nav_strategy(inputs)
	if (locale === "ja") return ja_nav_strategy(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_strategy(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_strategy(inputs)
	return ko_nav_strategy(inputs)
});
export { nav_strategy as "nav.strategy" }